/**
 * Project: Academy V2
 * File: GroupingIcon.tsx
 * Author: Colopi Salvatore
 * Author URI: https://salvatorecolopi.com
 * Created: Tue Jun 04 2024 at 19:39:26
 *
 * Copyright (c) 2024 Edusogno. All rights reserved.
 */

import React from "react";

interface GroupingIconProps extends React.SVGAttributes<SVGElement> {
  color?: string;
}

const GroupingIcon: React.FC<GroupingIconProps> = ({ color = "#8065C9", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="m1.205 14.772 4 .017c.305 0 .599.113.821.315a1.146 1.146 0 0 1 .104 1.594 1.21 1.21 0 0 1-.773.415l-.163.009-2.794-.014v8.557l2.8.002c.29 0 .57.102.788.288.218.185.36.44.4.72l.012.158c0 .282-.105.555-.296.767a1.21 1.21 0 0 1-.74.39L5.2 28h-4c-.29 0-.57-.103-.788-.288a1.158 1.158 0 0 1-.4-.72L0 26.833V15.938c0-.283.105-.556.297-.769a1.21 1.21 0 0 1 .745-.388l.163-.01Zm29.587 8.561c.304 0 .597.113.82.315a1.145 1.145 0 0 1 .112 1.589c-.193.229-.467.379-.768.419l-.164.01H9.197a1.22 1.22 0 0 1-.818-.314 1.145 1.145 0 0 1-.11-1.588c.191-.23.465-.38.766-.42l.162-.01h21.595Zm0-6.222c.304 0 .597.113.82.314a1.145 1.145 0 0 1 .112 1.589c-.193.23-.467.38-.768.42l-.164.01H9.197c-.304 0-.596-.113-.818-.314a1.145 1.145 0 0 1-.11-1.588c.191-.23.465-.38.766-.42l.162-.01h21.595ZM1.205 0l4 .017c.305 0 .599.113.821.316a1.146 1.146 0 0 1 .104 1.594 1.21 1.21 0 0 1-.773.414l-.163.01L2.4 2.337v8.543h2.8c.29 0 .57.103.788.288.218.185.36.441.4.72l.01.159c0 .282-.105.554-.295.767a1.21 1.21 0 0 1-.741.389l-.164.01h-4c-.29 0-.57-.102-.787-.287a1.158 1.158 0 0 1-.4-.72L0 12.046V1.168C0 .884.105.61.297.397A1.21 1.21 0 0 1 1.042.01L1.205 0Zm29.587 8.562c.304 0 .597.112.82.314a1.146 1.146 0 0 1 .112 1.589c-.193.229-.467.379-.768.42l-.164.01H9.197c-.304 0-.596-.113-.818-.315a1.145 1.145 0 0 1-.11-1.588c.191-.23.465-.38.766-.42l.162-.01h21.595ZM30.8 2.34c.304 0 .597.112.82.314a1.146 1.146 0 0 1 .112 1.589c-.193.229-.467.379-.768.419l-.164.01H9.207c-.305 0-.597-.111-.82-.313a1.145 1.145 0 0 1-.112-1.589c.193-.23.467-.38.768-.42l.164-.01H30.8Z"
      fill={color}
    />
  </svg>
);

export default GroupingIcon;
